export function evidenceDocumentIds(evidence) {
  try {
    const value = JSON.parse(evidence || '');
    return value?.kind === 'via-control-evidence-v1' && Array.isArray(value.document_ids)
      ? value.document_ids.filter((id) => typeof id === 'string') : [];
  } catch { return []; }
}

